import { SvgIcon } from '@mui/material'

export const ConfirmIcon = () => {
  return (
    <SvgIcon width="16" height="11" sx={{ marginTop: '12px' }}>
      <path
        d="M15 1a1 1 0 0 0-2 0L6 8 3 5a1 1 0 0 0-2 2l4 3a1 1 0 0 0 2 0l8-8a1 1 0 0 0 0-1Z"
        fill="#55A6FF"
      />
    </SvgIcon>
  )
}
